import { gql } from '@apollo/client'
import { BlockFragment } from 'app/features/shared/blocks'
import { BaseOfferBlock } from '../blocks.types'
import {
  LinkOnlyRedemptionBlockFragment,
  MultipleCodesRedemptionBlockFragment,
  Redemption,
  SingleCodeRedemptionBlockFragment,
} from 'app/features/offer/redemptions'

export const BrandFeaturedOfferBlockFragment: BlockFragment = {
  name: 'brandFeaturedOffer',
  fragment: gql`
    fragment brandFeaturedOffer on BrandFeaturedOffer {
      id
      blockName
      blockType
      title
      offer {
        id
        name
        description
        tag
        featuredImage {
          id
          url
          alt
        }
        expiresAt
        slug
        brand {
          id
          name
          slug
          logo {
            id
            url
            alt
          }
        }
        offerLinkLabel
        redeemInList
        canRedeem
        redemptions {
          ${LinkOnlyRedemptionBlockFragment.partialFragment}
          ${MultipleCodesRedemptionBlockFragment.partialFragment}
          ${SingleCodeRedemptionBlockFragment.partialFragment}
        }
        isBookmarked
      }
      excludedPlatforms {
          ios
          android
          web
        }
    }
  `,
  partialFragment: `
   ... on BrandFeaturedOffer {
      id
      blockName
      blockType
      title
      offer {
        id
        name
        description
        tag
        featuredImage {
          id
          url
          alt
        }
        expiresAt
        slug
        brand {
          id
          name
          slug
          logo {
            id
            url
            alt
          }
        }
        offerLinkLabel
        redeemInList
        canRedeem
        redemptions {
          ${LinkOnlyRedemptionBlockFragment.partialFragment}
          ${MultipleCodesRedemptionBlockFragment.partialFragment}
          ${SingleCodeRedemptionBlockFragment.partialFragment}
        }
        isBookmarked
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const BrandFeaturedOfferBlockType = 'brandFeaturedOffer'

export const canRenderFeaturedOfferBlock = (block: BrandFeaturedOfferBlock): boolean => {
  if (!block.offer) return false
  return true
}

export interface BrandFeaturedOfferBlock extends BaseOfferBlock {
  blockType: typeof BrandFeaturedOfferBlockType
  title?: string
  offer: {
    id: string
    name: string
    description?: string
    tag?: string
    featuredImage: {
      url: string
      alt: string
    }
    expiresAt?: string
    slug: string
    brand: {
      slug: string
      logo: {
        url: string
        alt: string
      }
    }
    offerLinkLabel?: string
    redeemInList: boolean
    canRedeem: boolean
    redemptions: Redemption[]
    isBookmarked: boolean
  }

  // Extra props
  isEmbedded?: boolean
}
